import { UserTheme } from "@bluframe/blublocks"
import { lighten } from "polished"
import colors from "styles/colors"

const SUBTITLE_LIGHTEN_AMOUNT = 0.1

const theme: UserTheme = {
  font: {
    family: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif'
  },
  palette: {
    alert: {
      contrast: colors.white,
      main: colors.california
    },
    disabled: {
      contrast: colors.white,
      main: colors.nobel
    },
    error: {
      contrast: colors.white,
      main: colors.trinidad
    },
    info: {
      contrast: colors.white,
      main: colors.osloGray
    },
    primary: {
      contrast: colors.white,
      main: colors.blazeOrange
    },
    secondary: {
      contrast: colors.white,
      main: colors.dodgerBlue
    },
    subtitle: {
      contrast: colors.white,
      light: lighten(SUBTITLE_LIGHTEN_AMOUNT, colors.nobel),
      main: colors.nobel
    },
    success: {
      contrast: colors.white,
      main: colors.apple
    },
    text: {
      contrast: colors.white,
      main: colors.tundora
    },
    warning: {
      contrast: colors.white,
      main: colors.schoolBusYellow
    }
  }
}

export default theme
